module.exports = "<img class=\"{{iconClass}}\" src=\"{{src}}\">\n"